

const Loading = () => {
  return (
    <div className='text-center m-5 '>
      <h1 className='display-1 fw-bold'>LOADİNG...</h1>
    </div>
  );
}

export default Loading